import { useMemo } from 'react';
import { buildIdsQueryFn } from './queryUtils';
import type { GridQueryInput } from './gridUtils';
import type { QueryResult } from '@flowqa/shared';

const stableIdsKey = (ids: Array<string | null | undefined>): string =>
  JSON.stringify(ids.filter((id): id is string => typeof id === 'string' && id.length > 0).sort());

export const useIdsQueryFn = <T>(
  ids: Array<string | null | undefined>,
  fetch: (input: GridQueryInput) => Promise<QueryResult<T>>,
): ((input: GridQueryInput) => Promise<QueryResult<T>>) => {
  const idsKey = useMemo(() => stableIdsKey(ids), [ids]);
  return useMemo(() => buildIdsQueryFn(ids, fetch), [fetch, idsKey]);
};
